<template>
  <BreadCrumb PageTitle="Position" />
  <PositionContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import PositionContent from "../../template-components/Utilities/Position/PositionContent.vue";

export default defineComponent({
  name: "PositionPage",
  components: {
    BreadCrumb,
    PositionContent,
  },
});
</script>